<template>
    <div class="mit-maps-page mit-page">
        <v-container fluid>
            <v-card class="mit-info-card">
              <v-card-title>Continue Adding Person</v-card-title>
              <v-card-subtitle class="caption">Continue adding a person to CSAIL</v-card-subtitle>
              <v-divider></v-divider>

              <v-card-text>
                <v-btn class="pt-0 mt-0 text-decoration-underline" @click="$router.back()" flat text small color="primary">< Back</v-btn>
                <MitActionsNewPersonContinue/>
              </v-card-text>
            </v-card>
      </v-container>
    </div>
</template>

<script>
  import MitActionsNewPersonContinue from '../../components/actions/MitActionsNewPersonContinue.vue';
  export default {
    name: 'MitActionNewPersonContinuePage',
    components: {
      MitActionsNewPersonContinue
    },
    data: function() {
      return {

      }
  },
    created(){

    },
    methods : {
    }
  }
</script>

<style lang="scss" scoped>
.mit-info-card {
  width:100%;
  height:100%;
}
</style>
